<template>
    <!-- Footer -->
    <MDBFooter :text="['center', 'lg-start', 'muted']">
      <!-- Section: Social media -->
      <section class="
          d-flex
          justify-content-center justify-content-lg-between
          p-4
          border-bottom
        " style="background-color: #144A78; color: white;">
        <!-- Left -->
        <div class="me-5 d-none d-lg-block" >
          <span style="color: white;">{{ $t('footerbanner') }}</span>
        </div>
        <!-- Left -->
        <!-- Right -->
        <div>
          <a href="https://www.facebook.com/ANTIC237" class="me-4 text-reset" target="_blank" rel="noopener noreferrer">
            <MDBIcon iconStyle="fab" icon="facebook-f"></MDBIcon>
          </a>
          <a href="https://x.com/antic_cameroun/status/1771125340443734511?s=20" class="me-4 text-reset" target="_blank" rel="noopener noreferrer">
            <MDBIcon iconStyle="fab" icon="twitter"></MDBIcon>
          </a>
          <a href="https://www.linkedin.com/company/antic/" class="me-4 text-reset" target="_blank" rel="noopener noreferrer">
            <MDBIcon iconStyle="fab" icon="linkedin"></MDBIcon>
          </a>
        </div>
        <!-- Right -->
      </section>
      <!-- Section: Social media -->
      <!-- Section: Links  -->
      <section class="">
        <MDBContainer class="text-center text-md-start mt-5">
          <!-- Grid row -->
          <MDBRow class="mt-3">
            <!-- Grid column -->
            <MDBCol md="3" lg="4" xl="3" class="mx-auto mb-4">
              <!-- Content -->
              <h6 class="text-uppercase fw-bold mb-4">
                <i class="fas fa-gem me-3" style="color: #144A78;"></i>CHECK-APP
              </h6>
              <p>
                {{ $t('appdes') }}
              </p>
            </MDBCol>
            <!-- Grid column -->
            <!-- Grid column -->
            <MDBCol md="2" lg="2" xl="2" class="mx-auto mb-4">
              <!-- Links -->
              <h6 class="text-uppercase fw-bold mb-4">{{ $t('otherRrc') }}</h6>
              <p>
                <a href="https://www.antic.cm/index.php/" class="text-reset" target="_blank" rel="noopener noreferrer">ANTIC</a>
              </p>
              <p>
                <a href="https://cirt.cm/" class="text-reset" target="_blank" rel="noopener noreferrer">CIRT</a>
              </p>

            </MDBCol>
            <!-- Grid column -->
            <!-- Grid column -->
            <MDBCol md="3" lg="2" xl="2" class="mx-auto mb-4">
              <!-- Links -->
              <h6 class="text-uppercase fw-bold mb-4">{{ $t('usefullinks') }}</h6>
              <p>
                <router-link
                to="/home"
                class="text-reset"
                >
                  {{ $t('saerch') }}
                </router-link>
              </p>
              <p>
                <a
                  href="https://incident.cirt.cm/en/report-incident"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-reset"
                >
                  {{ $t('reportIncident') }}
                </a>
              </p>
  

            </MDBCol>
            <!-- Grid column -->
            <!-- Grid column -->
            <MDBCol md="4" lg="3" xl="3" class="mx-auto mb-md-0 mb-4">
              <!-- Contacts Section -->
              <h6 class="text-uppercase fw-bold mb-4">{{ $t('contacts') }}</h6>
              
              <div class="d-flex align-items-center mb-3">
                <i class="fas fa-home me-3" style="color: #144A78; min-width: 20px;"></i>
                <span>{{ $t('actuallocation') }} {{ $t('townnation') }}</span>
              </div>
              
              <div class="d-flex align-items-center mb-3">
                <i class="fas fa-envelope me-3" style="color: #144A78; min-width: 20px;"></i>
                <span>alerts@cirt.cm</span>
              </div>
              
              <div class="d-flex align-items-center mb-3">
                <MDBIcon icon="phone" class="me-3" style="color: #144A78; min-width: 20px;" />
                <span>8202</span>
              </div>
            </MDBCol>
            <!-- Grid column -->
          </MDBRow>
          <!-- Grid row -->
        </MDBContainer>
      </section>
      <!-- Section: Links  -->
      <!-- Copyright -->
      <div class="text-center p-4" style="background-color: rgba(0, 0, 0, 0.05)">
        © 2024 Copyright:
        <a class="text-reset fw-bold" href="https://www.antic.cm/index.php/" target="_blank" rel="noopener noreferrer">ANTIC/CIRT</a>
      </div>
      <!-- Copyright -->
    </MDBFooter>
    <!-- Footer -->
  </template>

<script>
import {
  MDBFooter,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBIcon
} from 'mdb-vue-ui-kit';

export default {
 name : "FooterComponent",
  components: {
    MDBFooter,
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBIcon
  },
};
</script>